import {useAxiosClient} from "~/use/axios/client";
import {ProjectApi} from "~/gen/openapi/sblService";
import {keepPreviousData, useQuery} from "@tanstack/vue-query";
import {MS_HOUR, MS_MINUTE} from "~/constants/time";
import {extractErrorMessagesFromErrorOrResponse} from "~/helpers/errors";
import {useOnline} from "@vueuse/core";

export const useProjectService = () => {
    const { axiosClient } = useAxiosClient()
    const projectApi = new ProjectApi(undefined, '', axiosClient.value)
    const isOnline = useOnline()

    const nonInvoicedOrdersQueryOptions = {
        queryKey: ['projectOrdersNotInvoiced'],
        queryFn: async () => {
            try {
                return (await projectApi.projectOrdersNotInvoiced())?.data
            } catch (error) {
                return Promise.reject(extractErrorMessagesFromErrorOrResponse(error)[0])
            }
        },
        placeholderData: keepPreviousData,
        staleTime: 10 * MS_MINUTE,
        gcTime: MS_HOUR,
        refetchOnWindowFocus: false,
        enabled: isOnline,
    }

    const nonInvoicedOrdersQuery = () => useQuery(nonInvoicedOrdersQueryOptions)

    const projectsReady2CloseQueryOptions = {
        queryKey: ['projectProjectsReadyToClose'],
        queryFn: async () => {
            try {
                return (await projectApi.projectProjectsReadyToClose())?.data
            } catch (error) {
                return Promise.reject(extractErrorMessagesFromErrorOrResponse(error)[0])
            }
        },
        placeholderData: keepPreviousData,
        staleTime: 10 * MS_MINUTE,
        gcTime: MS_HOUR,
        refetchOnWindowFocus: false,
        enabled: isOnline,
    }

    const projectsReady2CloseQuery = () => useQuery(projectsReady2CloseQueryOptions)

    return {
        nonInvoicedOrdersQueryOptions,
        nonInvoicedOrdersQuery,
        projectsReady2CloseQueryOptions,
        projectsReady2CloseQuery,
    }
}